// "What's new" release notes, built in from RELEASE_NOTES.md (see vite.config.ts).
// Per user we remember the newest version they've looked at, to show a dot on "?" until they do.

export type Release = (typeof __WHATS_NEW__)[number];

const compare = (a: string, b: string) => {
  const pa = a.split('.').map(Number), pb = b.split('.').map(Number);
  for (let i = 0; i < Math.max(pa.length, pb.length); i++) {
    const d = (pa[i] || 0) - (pb[i] || 0);
    if (d) return d;
  }
  return 0;
};

export const RELEASES: Release[] = [...__WHATS_NEW__].sort((a, b) => compare(b.version, a.version));
export const LATEST_RELEASE: Release | undefined = RELEASES[0];

const seenKey = (userId: string) => `whats-new-seen:${userId}`;

export function hasUnseenRelease(userId: string | undefined): boolean {
  if (!userId || !LATEST_RELEASE) return false;
  try {
    const seen = localStorage.getItem(seenKey(userId));
    return !seen || compare(LATEST_RELEASE.version, seen) > 0;
  } catch { return false; } // no storage → never nag
}

export function markReleaseSeen(userId: string | undefined) {
  if (!userId || !LATEST_RELEASE) return;
  try { localStorage.setItem(seenKey(userId), LATEST_RELEASE.version); } catch { /* storage unavailable */ }
}
